import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableEuPidCustomsFields = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableEuPidCustomsFields);
};
